import React from "react";

interface RadioButtonProps {
	criterionKey: string;
	currentInput: string;
	id: string;
	label: string;
	onInputChange: (id: string) => void;
}

export default function RadioButton({
	currentInput,
	criterionKey,
	id,
	label,
	onInputChange,
}: RadioButtonProps) {
	const isChecked = (key: string) => currentInput === key;

	return (
		<div className="radio-input">
			<input
				type="radio"
				id={id}
				name={criterionKey}
				value={id}
				checked={isChecked(id)}
				onChange={() => onInputChange(id)}
			/>
			<label htmlFor={id}>{label}</label>
		</div>
	);
}
